import React from 'react';

import { Select } from 'antd';
import { connect } from 'react-redux';

import { RootState } from '../../reducers/store';

const { Option } = Select;

type TownsTagsPropsType = {
  onSelectChange: (towns: Array<{ id: string; name: string }>) => void;
  towns: Array<{ id: string; name: string }>;
  defaultValue: any;
  disabled: boolean;
};

const TownsTags: React.FC<TownsTagsPropsType> = ({
  onSelectChange,
  towns,
  defaultValue,
  disabled,
}) => {
  const onChange = (names: Array<string>) => {
    onSelectChange(towns.filter(({ name }) => names.includes(name)));
  };

  return (
    <Select
      id="townsTags"
      mode="multiple"
      allowClear
      placeholder="Insérez la(s) ville(s) ici"
      style={{ width: '100%' }}
      defaultValue={defaultValue}
      onChange={onChange}
      disabled={disabled}
    >
      {towns.map(({ id, name }, key) => {
        return (
          <Option id={`town${key}`} key={id} value={name}>
            {name}
          </Option>
        );
      })}
    </Select>
  );
};

const mapStateToProps = ({ towns }: RootState) => ({ towns });

export default connect(mapStateToProps)(TownsTags);
